export function isBase64Image(value?: string | null): boolean {
  if (!value) return false;

  return value.trim().startsWith('data:image');
}
